import { render, staticRenderFns } from "./shoppingIndex.vue?vue&type=template&id=88b21f68&scoped=true"
import script from "./shoppingIndex.vue?vue&type=script&lang=js"
export * from "./shoppingIndex.vue?vue&type=script&lang=js"
import style0 from "./shoppingIndex.vue?vue&type=style&index=0&id=88b21f68&prod&lang=css"
import style1 from "./shoppingIndex.vue?vue&type=style&index=1&id=88b21f68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b21f68",
  null
  
)

export default component.exports